var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDistributed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512.351 512.351",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m438.926 286.654 15.524-15.534h-161.953l149.667 149.667-21.202 21.203-149.807-149.808v162.313l15.394-15.394 21.203 21.202-51.402 51.762-52.132-51.762 21.203-21.202 15.744 15.734v-162.263l-149.427 149.418-21.203-21.203 149.668-149.667h-162.833l15.604 15.604-21.202 21.203-51.772-51.762 51.772-51.772 21.202 21.203-15.524 15.534h162.653l-150.448-150.447 21.203-21.202 150.307 150.297v-162.443l-15.814 15.814-21.213-21.202 52.212-51.772 51.332 51.772-21.203 21.202-15.324-15.324v162.343l150.687-150.687 21.202 21.202-150.447 150.447h161.933l-15.604-15.604 21.202-21.213 51.772 51.772-51.772 51.772z",
    fill: "#00358f",
    "data-original": "#00358f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m438.926 286.654 15.524-15.534h-161.953l149.667 149.667-21.202 21.203-149.807-149.808v162.313l15.394-15.394 21.203 21.202-51.402 51.762v-511.89l51.332 51.772-21.203 21.202-15.324-15.324v162.343l150.687-150.687 21.202 21.202-150.447 150.447h161.933l-15.604-15.604 21.202-21.213 51.772 51.772-51.772 51.772z",
    fill: "#012453",
    "data-original": "#012453"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e70b69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m496.681 420.845c-20.86-20.86-54.802-20.858-75.66 0-20.859 20.859-20.859 54.801 0 75.661 10.431 10.429 24.13 15.644 37.83 15.644s27.4-5.215 37.83-15.644c10.104-10.104 15.67-23.54 15.67-37.831s-5.565-27.727-15.67-37.83z",
    fill: "#e70b69",
    "data-original": "#e70b69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458.85 107.174c14.291 0 27.728-5.565 37.831-15.67 20.859-20.858 20.859-54.8.001-75.66h-.001c-20.859-20.859-54.8-20.859-75.661 0-20.858 20.86-20.858 54.802 0 75.66 10.104 10.105 23.54 15.67 37.83 15.67z",
    fill: "#e70b69",
    "data-original": "#e70b69"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fd4b49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m53.85 107.149c13.7 0 27.4-5.215 37.83-15.645 10.105-10.104 15.67-23.539 15.67-37.829 0-14.291-5.565-27.727-15.67-37.831-20.858-20.858-54.8-20.86-75.66 0-20.86 20.859-20.86 54.801 0 75.661 10.43 10.429 24.13 15.644 37.83 15.644z",
    fill: "#fd4b49",
    "data-original": "#fd4b49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.85 405.176c-14.291 0-27.726 5.565-37.831 15.67-20.858 20.859-20.858 54.801 0 75.66 10.104 10.104 23.54 15.67 37.831 15.67s27.726-5.565 37.83-15.67c20.859-20.858 20.859-54.8 0-75.66-10.104-10.105-23.539-15.67-37.83-15.67z",
    fill: "#fd4b49",
    "data-original": "#fd4b49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m138.705 179.583-10.355 2.69v147.804l128 73.903 128-73.903v-147.804l-10.355-2.69z",
    fill: "#00b3fe",
    "data-original": "#00b3fe",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.35 179.583v224.397l128-73.903v-147.804l-10.355-2.69z",
    fill: "#0274f9",
    "data-original": "#0274f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.35 182.273v.005l-128 73.869-128-73.869v-.005l128-73.903z",
    fill: "#01f5ff",
    "data-original": "#01f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.35 182.273v.005l-128 73.869v-147.777z",
    fill: "#00b3fe",
    "data-original": "#00b3fe",
    className: ""
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistributed);
export default __webpack_public_path__ + "static/media/distributed.028409eecbbe14e03f5e809941d16e7c.svg";
export { ForwardRef as ReactComponent };